import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Platform, App, NavController, Nav } from "ionic-angular";
import { EventProvider, EventDetailsModel } from "../event/event";
import { LoaderProvider } from "../loader/loader";
import { TranslateCompiler, TranslateParser, TranslateService } from "@ngx-translate/core";
import { EventTabsPage } from "../../pages/event/details/event-tabs/event-tabs";
import { ResultProvider } from "../result/result";
import { ResultDetailsPage } from "../../pages/results/result-details/result-details";
import { ResultSearchPage } from "../../pages/results/result-search/result-search";
import { TabsPage } from "../../pages/tabs/tabs";
import { InstantPaypal } from "../../pages/instantpaypal/instant-paypal";
import { InstantPaymentPage } from "../../pages/payment-system/instant-payment";
import { SuccessPaymentPage } from "../../pages/payment-system/success-payment/success-payment";
import { Subject } from "rxjs";

/*
  Generated class for the LocationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/


@Injectable()
export class DeeplinkProvider {
    object = null;
    lang: string = "de";
    currentRequest: string = "";
    eventSubject: Subject<String> = new Subject();

    constructor(
        public http: HttpClient,
        private platform: Platform,
        private eventService: EventProvider,
        private app: App,
        private loadingCtrl: LoaderProvider,
        private translate: TranslateService,
        private resultService: ResultProvider,
        private languageService: TranslateService
    ) {
        console.log('DeepLink Provider');
    }

    public onRequestEventSubject(): Subject<any> {
        return this.eventSubject;
    }

    handleUrl(url) {
        this.object = url;
        console.log('this.object: ' + this.object);

        if (typeof this.object != "string") {
            console.log(this.object.$link.fragment);
            console.log(this.object.$link.queryString)

            this.getOperation(this.object.$link.fragment);
        }
    }


    openEventDetails = (_event?: any) => {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        let parts = this.object.$link.queryString.split('&');

        let id = parts[0].split('=')[1];

        if (parts.length > 1) {
            this.lang = parts[1].split('=')[1];
            this.languageService.setDefaultLang(this.lang);
        }

        if (id.length > 0) {
            this.eventService.getEventDetails(Number(id)).then((event: EventDetailsModel) => {

                if (event.name.length < 1) {
                    this.openEventDetails(_event);
                    loader.dismiss();
                } else {
                    (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
                }
            });
        }
    };

    openTrophy = () => {
        console.log('openTrophy');

        let loader = this.loadingCtrl.create({ content: this.translate.instant("GLOBAL_LOADING") });
        loader.present();

        let vars = this.object.$link.queryString.split('&');

        let id = vars[0].split('=')[1];

        let cid = vars[1].split('=')[1];

        this.resultService.getResult(Number(id), Number(cid)).then(data => {
            (this.app.getRootNav() as NavController).push(ResultDetailsPage, { result: data });
            loader.dismiss();
        });
    };

    openThurnauResults() {
        this.currentRequest = "thurnauergebnisse";

        //switch to the resultsPage is executed on EventsSearchPage
    }


    //operations:
    //1 - showTrophy();
    //2 - openEventDetails();
    getOperation(f: string) {
        if (f.toLowerCase().includes("trophy")) this.openTrophy();
        else if (f.toLowerCase().includes("language")) this.translateLang();
        else if (f.toLowerCase().includes("events")) this.openEventDetails();
        else if (f.toLowerCase().includes("thurnauergebnisse")) this.openThurnauResults();
        else if (f.toLowerCase().includes("paypal")) this.openPayPal();
        else if (f.toLowerCase().includes("savepayment")) this.savePayment();
        else if (f.toLowerCase().includes("payment")) this.executePayment();
        else if (f.toLowerCase().includes("success_transaction")) this.finishPayment();
        else if (f.toLowerCase().includes("secondlayer")) this.onOpenSecondEventLayer();
    }

    translateLang() {
        let parts = this.object.$link.queryString.split('&');
        let lang = parts[0].split('=')[1];
        this.translate.setDefaultLang(lang);
    }

    onOpenSecondEventLayer() {
        let parts = this.object.$link.queryString.split('&');
        let enaOrig = parts[0].split('=')[1];
        if (parts.length > 1) {
            this.lang = parts[1].split('=')[1];
            this.translate.setDefaultLang(this.lang);
        }
        this.onRequestEventSubject().next(enaOrig.split('%20').join(' '));
    }

    finishPayment() {
        //https://m.gofo.rest/#/success_transaction?token=AAA&evId=1232&count=1&amount=12.50&firstName=slavik&lastName=spasibo&mail=test@gmail.com

        //https://m.gofo.rest/?payment_intent=pi_3K0OFwEfWOjwetWP038XKfgb&payment_intent_client_secret=pi_3K0OFwEfWOjwetWP038XKfgb_secret_f3YSBmLbpaKe9wIiSx0q40NUn&redirect_status=failed&source_type=giropay
        //#/payment_success?token=794ea2aed9881bc486ab5f155fd9d136a45d0ddbad286446bf13c8bc801674d9f334539913a3c9bf88397cd03447c3fd65a9225a21b8fe7cca2ca94067392e35&evId=-1&count=1&amount=24.0&firstName=test&lastName=test&mail=viacheslav-spasibo@rambler.ru

        let parts = this.object.$link.queryString.split('&');
        console.log('parts: ' + JSON.stringify(parts));

        if (this.object.$link.queryString.includes('succeeded')) {
            let parts = this.object.$link.queryString.split('#')[1].split('&');
            let c = {
                token: parts[0].split('=')[1],
                evId: parts[1].split('=')[1],
                count: parts[2].split('=')[1],
                amount: parts[3].split('=')[1],
                firstName: parts[4].split('=')[1],
                lastName: parts[5].split('=')[1],
                mail: parts[6].split('=')[1],
                lang: this.lang
            };

            this.eventService.saveCoupon(c).then((image) => {
                (this.app.getRootNav() as NavController).push(SuccessPaymentPage, { image: image, token: c.token });
            });
        } else {
            let c = {
                token: parts[0].split('=')[1],
                evId: parts[1].split('=')[1],
                count: parts[2].split('=')[1],
                amount: parts[3].split('=')[1],
                firstName: parts[4].split('=')[1],
                lastName: parts[5].split('=')[1],
                mail: parts[6].split('=')[1],
                lang: this.lang
            };

            (this.app.getRootNav() as NavController).push(InstantPaymentPage, { c: c });
        }

    }

    executePayment() {
        let parts = this.object.$link.queryString.split('&');
        let amount = parts[0].split('=')[1];
        let id = parts[1].split('=')[1];
        let currency = parts[2].split('=')[1];
        this.lang = parts[3].split('=')[1];
        this.languageService.setDefaultLang(this.lang);
        let address = parts[4].split('=')[1];

        if (amount && id) {
            (this.app.getRootNav() as NavController).push(InstantPaymentPage, { amount: amount, id: id, currency: currency, address:address});
        }
    }

    openPayPal = () => {
        console.log('save payment final procedure:');
        let parts = this.object.$link.queryString.split('&');
        let amount = parts[0].split('=')[1];
        console.log('amount: ', amount);
        let currency = parts[1].split('=')[1];
        console.log('currency: ', currency);
        // let amount = this.object.$link.queryString.split('=')[1];
        if (amount && currency) {
            (this.app.getRootNav() as NavController).push(InstantPaypal, { amount: amount, currency: currency });
        }
    }

    savePayment() {
        let loader = this.loadingCtrl.create({});
        console.log('savePayment-1');
        let parts = this.object.$link.queryString.split('&');
        let fail = false;
        let token = "";
        let amount = 0;
        let currency = "eur";
        console.log('savePayment-2');
        for (let i = 0; i < parts.length; i++) {
            if (this.object.$link.queryString.includes("failed")) {
                fail = true;
                console.log('savePayment-3');
            }
            if (parts[i].split('=')[0].includes("token")) {
                token = parts[i].split('=')[1];
            }
            if (parts[i].split('=')[0].includes("amount")) {
                amount = parts[i].split('=')[1];
            }
            if (parts[i].split('=')[0].includes("currency")) {
                currency = parts[i].split('=')[1];
            }
        }
        console.log('savePayment-4');

        //        https://m.gofo.rest/?payment_intent=pi_3K1rMlEfWOjwetWP1tckN106
        //&payment_intent_client_secret=pi_3K1rMlEfWOjwetWP1tckN106_secret_MGcMUeGHdlU2W8C1nlBsdmDuN
        //&redirect_status=failed&source_type=sofort#/savepayment?id=350464995&token=3678888bb51c34e70931694f51890d476039ce24c6e2f14c2d816091d2c84bbcd5a4d9d280fce54a99143d4b27ccb54f601016f8aed5a7b5623d8ff75610cfbf&amount=5&currency=EUR
        //
        let index = this.object.$link.queryString.indexOf("id");
        console.log('savePayment-5');
        let id = this.object.$link.queryString.substr(index, 15).split('&')[0].split('=')[1]
        console.log('savePayment-5');
        if (!fail) {
            this.eventService.savePaymentWithToken(id, token).then(() => {
                this.eventService.getEventDetails(Number(id)).then((event: EventDetailsModel) => {
                    loader.dismiss();
                    (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event });;
                });
            });
        } else {
            this.eventService.getEventDetails(Number(id)).then((event: EventDetailsModel) => {
                loader.dismiss();
                (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event, redirect: true, amount: amount, currency: currency });;
            });
        }
    }

    getCurrentRequest() {
        return this.currentRequest;
    }
}


// WEBPACK FOOTER //
// /src/providers/deeplink/deeplink.ts